import React from 'react';
import Search_icon from '../../images/Blog/Search_icon.png'

function Blog_filter () {
    return(
    <>
        {/* <hr className='text-[#D1D1D1]' /> */}

        {/* old Filter Section */}
        <div className='bg-[#F8F6F6] py-[30px] px-6 mt-10'>
            <div className='font-alibaba flex flex-wrap justify-start gap-x-8 gap-y-5 text-[18px] text-font-grey lg:justify-center lg:gap-x-[50px]'>
                <button className='focus:underline'>Home</button>
                <button className='focus:underline'>Buying</button>
                <button className='focus:underline'>Selling</button>
                <button className='focus:underline'>Renting</button>
                <button className='focus:underline'>Workplace</button>
                <button className='focus:underline'>Neighborhood</button>
                <button className='focus:underline'>Investment</button>
                <button className='focus:underline'>Market Trends</button>
            </div>
        </div>

        {/* <hr className='text-[#D1D1D1]' /> */}


        {/* old Filter Section */}
        <div className='flex justify-end px-6 sm:mr-16  md:px-0 hidden'>
            <div className='flex flex-wrap justify-start gap-x-[45px] gap-y-5 font-[lato] text-[#5F5D5E] text-[16px] font-semibold leading-[26.6px] tracking-[0.19px] my-5 sm:justify-center'>
                <button className='focus:text-[#F8DA00]'>Learning Center</button>
                <button className='focus:text-[#F8DA00]'>Buying</button>
                <button className='focus:text-[#F8DA00]'>Workplace</button>
                <button className='focus:text-[#F8DA00]'>Neighbourhood </button>
                <button className='focus:text-[#F8DA00]'>Financing</button>
                <button className='focus:text-[#F8DA00]'>Cities</button>

                <div className="max-w-[205px] my-auto relative rounded-md shadow-sm lg:ml-[58px]">
                    <div className="absolute inset-x-0 top-3 left-0 flex items-center pl-3">
                        <img className='w-[16px]' src={Search_icon} alt='Search icon' />
                    </div>
                    <input type="text"
                        className="sm:w-[205px] h-[37px] rounded-[4px] border-[0.8px] border-[#D1D4D6] py-1.5 pl-10 text-[#D1D4D6] outline-none placeholder:text-[#D1D4D6] placeholder:font-medium sm:text-sm sm:leading-6"
                        placeholder="Search Learning Center"
                    />
                </div>
            </div>
        </div>

        
    </>
    );
}

export default Blog_filter;